<section id="sasTncUser">
  <div class="row-block">
    <div class="modal fade modal-bg" id="myModal" [ngClass]="{'in': showSasTnC}" *ngIf="showSasTnC"
      style="display: block !important">
      <div class="wrapper">
        <div class="modal-body">
          <header>
            <h3 id="model-header"></h3>
            <button type="button" class="modal-close" (click)="closeSasTnC()" id="termsAndConClose" tabindex="0"
              [attr.aria-label]="('close' | translate)">× </button>
          </header>
          <div class="modal-content terms-condition" tabindex="0">
            <h2 class="title-center-align">Terms and Conditions for Internet Access</h2>
            <div *ngFor="let section of termsSections; let i = index">
             
              <div class="accordion-header" (click)="toggleSection(i)">
                <span class="arrow" [ngClass]="{ 'open': section.open }"></span>
                <h3>{{ section.title }}</h3>
              </div>
              <div class="accordion-content" [ngClass]="{ 'hidden': !section.open }" [innerHTML]="section.content">
                <p>{{ section.content }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>